import {Avatar, IconButton, Input, Tooltip} from "@mui/material";
import * as mime from "mime"
import {CloudUpload} from "@mui/icons-material";
import * as React from "react";
import {useEffect, useState} from "react";
import {DRIVE_TYPES, UPLOAD_STATUS} from "../../config/appConst";
import useDrive from "../../hooks/useDrive";
import useNotification from "../../hooks/useNotification";
import FileService from "../../services/FileService";
import DriveService from "../../services/DriveService";
import FileExistConformation from "../FilesAndFoldersTbl/FileExistConformation";
import ProgressSnack from "./ProgressSnack";
import axios from "axios";

export default function FileUpload({droppedFile, hideUploadButton}) {
    const {changeCurrentDrive, changeUploadStatus, CurrentDrive} = useDrive();
    const {addNotification} = useNotification();

    const [openExistConfirmation, setOpenExistConfirmation] = useState(false);
    const [file, setFile] = useState(new Blob());
    const [fileDetailObject, setFileDetailObject] = useState({});
    const [existenceRes, setExistenceRes] = useState({});
    const [progress, setProgress] = useState(0);
    useEffect(() => {
        if (droppedFile) {
            setProgress(0)
            setFile(droppedFile);
        }
    }, [droppedFile])

    useEffect(() => {
        // console.log(file);
        if (file && file.size > 0) {
            setProgress(0)
            let file_name = file.name;
            let size = file.size;
            let {parent} = CurrentDrive;
            parent = parent === "" ? "/" : parent;
            fileServeValidator(file_name, size, parent).then(existsRes => {
                {
                    setExistenceRes(existsRes);

                }
            })

        }
    }, [file]);
    useEffect(() => {
        if (existenceRes) {
            if (existenceRes.exists === 0) {
                doUpload().then(() => {
                    setFile(new Blob());
                    setExistenceRes({});
                })
            } else {
                setOpenExistConfirmation(existenceRes.exists === 1)
            }
        }

    }, [existenceRes])
    // const handleOpenForm = () => {
    //     setOpenForm(!openForm);
    // }
    const handleUploadFile = async event => {
        event.preventDefault();
        // console.log(event.target.files[0]);
        let newFile = event.target.files[0];
        setFile(newFile);
    }
    const fileServeValidator = async (file_name, size, folder) => {
        try {
            const {driveType} = CurrentDrive;
            return await FileService.checkFile({file_name, size, folder}, driveType);
        } catch (e) {
            console.error(e);
        }

    }


    const doUpload = async (saveAsNew = false) => {
        changeUploadStatus(UPLOAD_STATUS.UPLOADING);
        let {parent, driveType} = CurrentDrive;

        parent = parent === "" ? "/" : parent;
        let file_name;
        if (saveAsNew) {
            // file.name = existenceRes.file_name;
            file_name = existenceRes.file_name;
        } else {
            file_name = file.name;
        }
        let size = file.size;
        setFileDetailObject({file_name, size, folder: parent});
        const bucketUrl = await DriveService.getS3BucketUrl({file_name, size, folder: parent}, driveType);
        let contentType = mime.getType(file_name)
        let reader = new FileReader();
        reader.readAsDataURL(file);
        // console.log("doUpload", file);
        reader.onloadend = async () => {
            await axios({
                method: 'PUT',
                url: bucketUrl,
                headers: {
                    'Content-Type': (contentType || 'application/octet-stream'),
                },
                onUploadProgress: (p) => {
                    // console.log("progress", p);
                    // console.log("progress-1", (p.loaded / p.total) * 100);
                    setProgress((p.loaded / p.total) * 100);
                    //this.setState({
                    //fileprogress: p.loaded / p.total
                    //})
                },
                data: file
            });
            changeUploadStatus(UPLOAD_STATUS.COMPLETING);
            const drive = await DriveService.getFileTree(parent, driveType);
            changeCurrentDrive({
                parent,
                drive: (driveType.length === 0 ? drive : {}),
                sharedDrive: driveType === DRIVE_TYPES.SHARED ? drive : {},
                driveType
            });
            changeUploadStatus(UPLOAD_STATUS.DONE);
            document.getElementById("file-upload-icon").value = null;
            addNotification({
                type: 'success',
                message: "File uploaded successfully"
            });

        }
    }

    return <>
        {

            // !hideUploadButton ? <Avatar variant={"rounded"} style={{width: "45px", height: "45px", backgroundColor: blue[400]}}>
            !hideUploadButton ?
                <Avatar variant={"rounded"} style={{width: "45px", height: "45px", backgroundColor: "#8c3b61"}}>

                    <Tooltip title="Upload files">

                        <label htmlFor="file-upload-icon">
                            <Input accept="image/*" id="file-upload-icon" type="file" style={{display: "none"}}
                                   onChange={(event) => {
                                       handleUploadFile(event)
                                   }}
                            />
                            <IconButton component="span" style={{color: "#fff"}}>
                                <CloudUpload/>
                            </IconButton>
                        </label>
                    </Tooltip>
                    <FileExistConformation open={openExistConfirmation} setOpen={setOpenExistConfirmation}
                                           doUpload={doUpload}/>
                </Avatar> : <FileExistConformation open={openExistConfirmation} setOpen={setOpenExistConfirmation}
                                                   doUpload={doUpload}/>

        }

        {
            <ProgressSnack value={progress} fileDetail={fileDetailObject}/>

        }
    </>

}